// extracted by mini-css-extract-plugin
export default {"titleBar":"CategoryTitle__titleBar--1Fh","title":"CategoryTitle__title--1Bd","enterDrawLink":"CategoryTitle__enterDrawLink--2FF","link":"CategoryTitle__link--3gN"};